angular.module('core')
  .service('dblStudentMilestonesService', [
        'dblActivityFactoryService',
        'dblArrayService',
        'translateFilter',
    function(
        dblActivityFactoryService,
        dblArrayService,
        translateFilter) {

    var LESSON_GROUPS_COMPLETED_TITLE = translateFilter('milestones.lessonGroupsCompleted');
    var LESSON_GROUPS_IN_PROGRESS_TITLE = translateFilter('milestones.lessonGroupsInProgress');
    var STANDARDS_COMPLETED_TITLE = translateFilter('milestones.standardsAchieved');

    var NO_ACTIVITY_MESSAGE = translateFilter('errors.noActivityMessage');
    var NONE_MESSAGE = translateFilter('errors.noneMessage');
    var NO_LESSON_GROUPS_COMPLETED = NONE_MESSAGE;
    var NO_LESSON_GROUPS_IN_PROGRESS = NONE_MESSAGE;
    var NO_STANDARDS_COMPLETED = NONE_MESSAGE;

    function getLessonGroupsCompleted (activities, limit) {
        var milestones = dblActivityFactoryService.getLessonGroupsCompleted(activities);

        return dblArrayService.limit(milestones, limit);
    }

    function getLessonGroupsCompletedGroup (activities) {
        var lessonGroupsCompleted = getLessonGroupsCompleted(activities);

        return {
            title: LESSON_GROUPS_COMPLETED_TITLE,
            events: lessonGroupsCompleted,
            noDataMessage: NO_LESSON_GROUPS_COMPLETED
        };
    }

    function getLessonGroupsInProgress(activities, limit) {
        var milestones = dblActivityFactoryService.getLessonGroupsInProgress(activities);

        return dblArrayService.limit(milestones, limit);
    }

    function getLessonGroupsInProgressGroup (activities) {
        var lessonGroupsInProgress = dblActivityFactoryService.getLessonGroupsInProgress(activities);

        return {
            title: LESSON_GROUPS_IN_PROGRESS_TITLE,
            events: lessonGroupsInProgress,
            noDataMessage: NO_LESSON_GROUPS_IN_PROGRESS
        };
    }

    function getStandardsCompletedGroup (activities) {
        var n = 0;
        var standardsCompleted = _.filter(activities, function (activity) {
            // Standards Achieved should display up to 10 cards
            return activity.isStandardCompleteActivity() && n++ < 10;
        });

        return {
            title: STANDARDS_COMPLETED_TITLE,
            events: standardsCompleted,
            noDataMessage: NO_STANDARDS_COMPLETED
        };
    }

    /**
     * From the activities, return a list of milestones sorted by lesson group in progress needs attention >
     * lesson group in progress > lesson group completed.
     *
     * @param {number} typeLimit - The max number of each type of milestone to return.  Takes milestones in order.
     * @param {number} limit - The max number of milestones to return.  Takes milestones in order.
     **/
    function getMilestones (activities, typeLimit, limit) {
        var lessonGroupsCompleted = getLessonGroupsCompleted(activities, typeLimit);
        var lessonGroupsInProgress = getLessonGroupsInProgress(activities, typeLimit);

        var milestones = lessonGroupsInProgress.concat(lessonGroupsCompleted);

        return dblArrayService.limit(milestones, limit);
    }

    function getMilestonesGroups (activities, showStandards) {
        var milestones = [
            getLessonGroupsCompletedGroup(activities),
            getLessonGroupsInProgressGroup(activities)
        ];

        if (showStandards) {
            milestones.push(getStandardsCompletedGroup(activities));
        }

        return milestones;
    }

    return {
        getMilestones: getMilestones,
        getMilestonesGroups: getMilestonesGroups,
        NO_ACTIVITY_MESSAGE: NO_ACTIVITY_MESSAGE
    };
  }]
);
